module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/153RMvK/tc-custom/9781638296966.jpg?1728724800293",
      "alt": "This image is the cover for the book Building 8"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Building 8\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("In the heart of a dystopian metropolis, Building 8 stands as a silent witness to the lives and struggles of its inhabitants. Anthony C. Mazzella’s gripping narrative plunges readers into a world where reality bends and the ordinary collides with the surreal. As the central business district is besieged by chaotic flying machines and destruction reigns, the top floor of Building 8 remains a curious sanctuary of calm. Within its walls, two men go about their business, seemingly oblivious to the mayhem below, embodying the eerie contrast between normalcy and chaos that defines the story.")]), _c('p', [_vm._v("Mazzella’s vivid imagination and keen insights into human nature drive this thought-provoking tale, weaving together elements of science fiction and psychological thriller. As the characters navigate a landscape of fear, uncertainty, and hidden truths, "), _c('em', [_vm._v("Building 8")]), _vm._v(" challenges readers to question their perceptions of reality and the thin veneer that separates order from disorder. This novel is a powerful exploration of resilience, human connection, and the mysterious forces that shape our lives, making it a must-read for fans of speculative fiction and those who enjoy a deep dive into the complexities of the human psyche.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Anthony C. Mazzella\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }), _c('p', {
    staticStyle: {
      "margin-top": "0mm",
      "margin-right": "0mm",
      "margin-bottom": "0mm",
      "margin-left": "0mm",
      "font-size": "21px",
      "font-family": "\"Adobe Garamond Pro Bold\",serif",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "15px",
      "font-family": "\"Times New Roman\",serif"
    }
  }, [_vm._v("Anthony C. Mazzella was born many years ago but can’t specifically remember the incident. New York City was his home but the South Bronx in the ’60s was his playground. It was a simple life of sewer-to-sewer stick ball and summers spent in the “country”. As Anthony got older, he learned that there is good and bad, God and Satan, and a constant back and forth between them, all existing in the hearts and minds of people. He hopes you learn this too.")])]), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0